import React, { useEffect, useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { Outlet } from "react-router-dom";
import Navbar from "pages/navbar";
import Sidebar from "../../components/Sidebar";
import SnackbarComponent from "components/SnackbarComponent";

function Layout() {
  const isLargeScreen = useMediaQuery("(min-width:1000px)");
  const [isSideBarOpen, setIsSideBarOpen] = useState(
    isLargeScreen ? true : false
  );

  useEffect(() => {
    if (isLargeScreen) {
      setIsSideBarOpen(true);
    }
  }, [isLargeScreen]);

  return (
    <Box display={isLargeScreen ? "flex" : "block"} width="100%" height="100%">
      <Sidebar
        isLargeScreen={isLargeScreen}
        drawerWidth="220px"
        isSideBarOpen={isSideBarOpen}
        setIsSideBarOpen={setIsSideBarOpen}
      />
      <Box flexGrow={1}>
        <Navbar
          isSideBarOpen={isSideBarOpen}
          setIsSideBarOpen={setIsSideBarOpen}
        />
        <Outlet />
      </Box>
      <SnackbarComponent />
    </Box>
  );
}

export default Layout;
